import type { Faq } from "@components/Faq.js";
import type { Tenant } from "@core/schema/Tenant.js";

export function getFaqsDigi(tenant: Tenant): Faq[] {
	return [
		{
			question: "Jaký bude hlavní přínos digitalizace a automatizace pro naši firmu?",
			answer:
				"Díky digitalizaci a automatizaci procesů ušetříte čas vy i vaši zaměstnanci, snížíte chybovost, zlepšíte zákaznickou zkušenost nebo získáte větší kontrolu nad daty. Zároveň ušetříte spoustu peněz – např. za tisk, personální náklady apod.",
		},
		{
			question: "Jak dlouho trvá digitalizace firemních procesů?",
			answer:
				"Vždy záleží na rozsahu. Digitalizace/automatizace jednoho nebo dvou procesů může být hotová v řádu dnů až týdnů, rozsáhlejší práce zaberou více času (např. 2 měsíce).",
		},
		{
			question: "Můžeme na digitalizaci a automatizaci firmy využít nějaké dotace?",
			answer: "Ano, existují různé granty a dotační programy podporující digitalizaci malých a středních podniků.",
		},
		{
			question:
				"Rádi bychom zautomatizovali procesy v rámci zákaznického servisu. Která konkrétní řešení nám v tomto ohledu pomohou?",
			answer:
				"Co se týče zákaznického servisu, naši zákazníci mají v oblibě chatboty, automatizované e-mailové odpovědi nebo CRM systémy na míru.",
		},
		{
			question:
				"Všimli jsme si, že trendem v oblasti digitalizace a automatizace je umělá inteligence. Pracujete i s AI?",
			answer:
				"Ano, ve Fastest držíme krok s dobou a tam, kde to dává smysl, dodáváme zákazníkům řešení využívající umělou inteligenci (např. chatboti).",
		},
		{
			question: "Vyplatí se nám digitalizace, i když jsme malá firma?",
			answer:
				"Ano, i malým a středním firmám se digitalizace vyplatí – naši klienti již v horizontu několika měsíců sledují úspory nákladů nebo času.",
		},
	];
}
